export default function validatePhoneNumber(number) {
	return /^((\+|0+)\d{2,3})?\s?(\d|\s)+$/.test(number)
}
